import React from "react";
import Header from "../components/layout/Header";
import MiddleBanner from "../components/common/MiddleBanner";
import Space from "../components/common/Space";
import Footer from "../components/layout/Footer";
import Img1 from "../assets/images/youth/Img5.webp";
import Img2 from "../assets/images/youth/Img4.webp";
import Img3 from "../assets/images/youth/Img3.webp";
import Img4 from "../assets/images/youth/Img1.webp";
import Img5 from "../assets/images/youth/Img5.webp";
import Icon1 from "../assets/images/about-us/Icon1.webp";
import Icon2 from "../assets/images/about-us/Icon2.webp";
import Icon3 from "../assets/images/about-us/Icon3.webp";
import Icon4 from "../assets/images/about-us/Icon4.webp";
import Banner from "../assets/images/banners/YouthGroup.webp";
import BgImage from "../assets/images/about-us/AboutUsMiddleBanner.webp";
import BoardMembers from "../components/common/BoardMembers";
import AboutUsTabs from "../components/services/AboutUsTabs";
import { Helmet } from "react-helmet";

const YouthGroup = () => {

  return (
    <>
    <Helmet>
      <title> Youth Group | Huntsville Islamic Center</title>
    </Helmet>
    <section id="website-responsive" className="px-0">
    <section className="container-fluid bg-common-banner"  style={{backgroundImage:`url(${Banner})`}}>
    <Header/>
    <div className="fs-banner-title text-white fw-500 text-center py-5">
      <div className="py-md-5 mb-md-5">
        Youth Group
      <div className="py-3 py-lg-4" />
      </div>
    </div>
    </section>
           <div className="py-4 py-md-5" />
    <section className="container-fluid text-md-center col-11 col-lg-9 mx-auto">
      <div className="">
        <div className="lh-sm">
        <div className="fs-ss-40 fw-600">
        Empowering Young Muslims, Building a Stronger Community 
        </div>
        <div className="text-ss-secondary fs-ss-22 fw-500">
        Fostering Faith and Personal Growth 
        </div>
        </div>
        <div className="fs-ss-18 fw-400 mt-3">
        The HIC Youth Group brings young Muslims in the community together to nurture spiritual growth, cultural understanding, and personal development. Through religious education, community service opportunities, and social events, the group creates a supportive environment for discussing faith, identity, and modern life challenges. 
        </div>
      </div>
    </section>
    <div className="py-4 py-md-5" />
    <div className="py-4 py-md-3" />
    <section className="container-fluid">
      <div className="row justify-content-center align-items-center gy-4">
        <div className="col-8 col-md-4 d-block d-md-none">
          <img src={Img1} className="w-100 px-lg-5" alt="" />
        </div>
      <div className="col-11 col-md-7 col-lg-5 pe-0 pe-md-5 pe-lg-0">
        <div className="fs-ss-40 fw-600">
        Mini Youth Group  
        </div>
        <div className="text-ss-secondary fs-ss-22 fw-500">
        Fun, Faith, and Friendship for Kids 
        </div>
        <div className="fs-ss-18 fw-400 text-start mt-3">
        The mini youth group provides a safe and fun environment for our youngest participants. The group meets once a month. Activities are different every month and include:
          <ul className="mt-3">
            <li> Lessons and stories from the Quran. </li>
            <li> Character building activities and talks based on the Sunnah </li>
            <li> Outdoor activities as well as visits to indoor parks/ rec places. </li>
            <li> Games, arts and crafts, fun interactive activities. </li>
          </ul>
          <div className="mt-3">
          <strong>Age Groups:</strong> Separated into two sub-groups: Ages 5–7 and Ages 8-10
          </div>
          <div className="mt-2">
          Participants must RSVP for each event to help us create a safe, organized, and meaningful experience for all children. Parents are encouraged to volunteer.
          </div>
          <div className="mt-5 text-center text-md-start">
          <a href="https://chat.whatsapp.com/CbYsF6fIg7sBkqrsG5ZWJZ?mode=hqrt2" target='_blank' className="text-decoration-none rounded-5 border-0 btn-padding-middle py-3 bg-ss-primary fs-ss-20 text-white fw-500 hover-btn">
          Join WhatsApp Group
        </a>
          </div>
        </div>
        </div>
        <div className="col-8 col-md-4 pt-5 pt-md-0 d-none d-md-block">
          <img src={Img1} className="w-100 px-lg-5" alt="" />
        </div>
      </div>
    </section>
    <div className="py-4 py-md-5" />
    <div className="py-4 py-md-3" />
    <section className="container-fluid">
      <div className="row justify-content-center align-items-center gy-4">
        <div className="col-8 col-md-4">
          <img src={Img3} className="w-100 px-lg-5" alt="" />
        </div>
        <div className="col-11 col-md-7 col-lg-5 ps-md-5">
        <div className="fs-ss-40 fw-600">
        Ansar Brothers  
        </div>
        <div className="text-ss-secondary fs-ss-22 fw-500">
        Middle School Boys | starting at age 11
        </div>
        <div className="fs-ss-18 fw-400 text-start mt-3">
        Ansar Brothers provides a supportive environment for middle school boys to learn, develop, and build brotherhood. This group meets once a month and offers opportunities to:
          <ul className="mt-3">
            <li> Connect with peers </li>
            <li> Engage in meaningful guided discussions </li>
            <li> Build character and leadership skills </li>
            <li> Participate in activities led by youth mentors </li>
          </ul>
          Participants are required to RSVP for each event to support effective planning and maintain a safe, organized experience.
          <div className="mt-5 text-center text-md-start">
         <a href="https://chat.whatsapp.com/FWXTryvhj3O1EzZUUlMsvW?mode=hqrt2" target='_blank' className="text-decoration-none rounded-5 border-0 btn-padding-middle py-3 bg-ss-primary fs-ss-20 text-white fw-500 hover-btn">
          Join WhatsApp Group
        </a>
          </div>
        </div>
        </div>
      </div>
    </section>
        <div className="py-4 py-md-3" />
    <div className="py-4 py-md-5" />
        <MiddleBanner
    BgImage={BgImage}
    Title="Together in Faith"
    SubTitle="Together in Service"
    BtnTitle="Become a Member"
    />
    <div className="py-4 py-md-3" />
        <div className="py-md-4 py-md-5" />
    <section className="container-fluid">
      <div className="row justify-content-center align-items-center gy-4">
        <div className="col-8 col-md-4 pt-5 pt-md-0 d-block d-md-none">
          <img src={Img2} className="w-100 px-lg-5" alt="" />
        </div>
        <div className="col-11 col-md-7 col-lg-5 pe-0 pe-md-5 pe-lg-0">
        <div className="fs-ss-40 fw-600">
        Noor Sisters  
        </div>
        <div className="text-ss-secondary fs-ss-22 fw-500">
        Middle School Girls | starting at age 11
        </div>
        <div className="fs-ss-18 fw-400 text-start mt-3">
        Noor Sisters is a dedicated space for middle school girls to grow, connect, and build confidence in a supportive Islamic environment. This group meets once a month and provides opportunities to:
          <ul className="mt-3">
            <li> Connect with peers </li>
            <li> Engage in thoughtful discussions </li>
            <li> Build leadership and communication skills </li>
            <li> Participate in activities led by trained youth leaders </li>
          </ul>
          Participants must RSVP for each event to ensure a well-coordinated and safe environment.
          <div className="mt-5 text-center text-md-start">
         <a href="https://chat.whatsapp.com/Jv0R7eZhiSs8ckZwkjCGKp?mode=hqrt2" target='_blank' className="text-decoration-none rounded-5 border-0 btn-padding-middle py-3 bg-ss-primary fs-ss-20 text-white fw-500 hover-btn">
          Join WhatsApp Group
        </a>
          </div>
        </div>
        </div>
        <div className="col-8 col-md-4 pt-5 pt-md-0 d-none d-md-block">
          <img src={Img2} className="w-100 px-lg-5" alt="" />
        </div>
      </div>
    </section>
    <div className="py-4 py-md-5" />
        <div className="py-4 py-md-3" />
    <section className="container-fluid">
      <div className="row justify-content-center align-items-center gy-4">
        <div className="col-8 col-md-4">
          <img src={Img4} className="w-100 px-lg-5" alt="" />
        </div>
        <div className="col-11 col-md-7 col-lg-5 ps-md-5">
        <div className="fs-ss-40 fw-600">
        Youth Group  
        </div>
        <div className="text-ss-secondary fs-ss-22 fw-500">
        Co-Ed | Grades 9+
        </div>
        <div className="fs-ss-18 fw-400 text-start mt-3">
        The Youth Group serves as our broader teen leadership and engagement program, designed to help young leaders grow, collaborate, and contribute meaningfully to the community. This group meets at least once a month and empowers teens through opportunities to:
          <ul className="mt-3">
            <li> Plan and organize youth events and activities </li>
            <li> Lead outreach and community service projects </li>
            <li> Develop and implement initiatives that support the mosque and wider community </li>
            <li> Collaborate with peers, build confidence, and shape future youth programming </li>
          </ul>
          All participants must RSVP for each event so we can plan effectively and ensure a safe, well-coordinated experience.
          <div className="mt-5 text-center text-md-start">
         <a href="https://chat.whatsapp.com/HRAYKbeyqTCFk8FHvm8Gxs?mode=hqrt2" target='_blank' className="text-decoration-none rounded-5 border-0 btn-padding-middle py-3 bg-ss-primary text-white fs-ss-20 fw-500 hover-btn">
          Join WhatsApp Group
        </a>
          </div>
        </div>
        </div>
      </div>
    </section>
    <div className="py-4 py-md-5" />
        <div className="py-4 py-md-3" />
    <section className="container-fluid text-md-center col-11 col-lg-9 mx-auto">
      <div className="">
        <div className="lh-sm">
        <div className="fs-ss-40 fw-600">
        Youth Council: Shaping the Future 
        </div>
        </div>
        <div className="fs-ss-18 fw-400 mt-3">
        The Youth Council guides the group's initiatives with leadership from Noor Sisters and Ansar Brothers. They organize events, plan community outreach, and shape future activities, empowering members to actively participate, collaborate, and make a positive impact on the youth group and the broader community. 
        </div>
      </div>
    </section>
    <div className="py-4 py-md-5" />
    <Footer/>
    </section>
    <style jsx>{`
      .hover-btn:hover {
        background-color: #fcb254 !important;
        transition: background-color 0.3s ease;
      }
    `}</style>
    </>
  );
}

export default YouthGroup